"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ItemCostBenefit = void 0;
var _mui = require("@ori-ui/mui");
var _constants = require("../constants");
var _context = require("../context");
var _CostBenefit = require("./CostBenefit");
var _jsxRuntime = require("react/jsx-runtime");
const Numbers = (0, _mui.styled)('div')(({
  ownerState: {
    isSmall
  },
  theme
}) => ({
  alignSelf: 'end',
  justifySelf: 'end',
  display: 'grid',
  gridTemplateColumns: 'auto',
  alignItems: 'end',
  justifyItems: 'end',
  gap: theme.spacing(1),
  width: '100%',
  ...(!isSmall && {
    [theme.breakpoints.up('sm')]: {
      maxWidth: `${theme.breakpoints.values.md - 1 - _constants.SM_IMAGE_SIZE + _constants.SM_COLUMN_GAP + 2 * _constants.SM_OUTER_PADDING}px`
    },
    [theme.breakpoints.up('md')]: {
      width: 'fit-content',
      maxWidth: 230
    }
  })
}));
const ItemCostBenefit = () => {
  const {
    isSmall,
    itemTestId
  } = (0, _context.useItemContext)();
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Numbers, {
    ownerState: {
      isSmall: isSmall ?? false
    },
    "data-testid": `${itemTestId}-numbers`,
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_CostBenefit.ItemBpBv, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CostBenefit.ItemPrice, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CostBenefit.ItemUnitPrice, {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(_CostBenefit.ItemCataloguePrice, {})]
  });
};
exports.ItemCostBenefit = ItemCostBenefit;
